export default __webpack_public_path__ + "335742c6dd16cba0b3cef99483e432fc.png";